import { useMemo } from "react"
import moment from "moment"

/**
 * Calculates start and end dates for a calendar view based on params.
 * @param {Object} params - Calendar filter params (must include date, range)
 * @returns {{start: string, end: string}} - Start and end ISO date strings
 */
export function useCalendarDateRange(params) {
  return useMemo(() => {
    if (!params.date || !params.range) return {}
  const date = moment(params.date)
    const dates = {}

    if (params.range === "month") {
      dates.start = date.clone().startOf("month").day(0).format("YYYY-MM-DD")
      dates.end = date.clone().endOf("month").day(6).format("YYYY-MM-DD")
    } else if (params.range === "week") {
      dates.start = date.clone().day(0).format("YYYY-MM-DD")
      dates.end = date.clone().day(6).format("YYYY-MM-DD")
    } else {
      dates.start = date.clone().startOf("day").format("YYYY-MM-DD")
      dates.end = date.clone().endOf("day").format("YYYY-MM-DD")
    }

    return dates
  }, [params.date, params.range])
}
